



















































































































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { ApplicationChangeType} from '../fixed/ApplicationChangeType';
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// 個別
// import TemporarySave from '../../CommonUtils/components/TemporarySave.vue'; // ファイル一時保存機能の呼び出し
import { loadingControlModule } from '../../store/modules/LoadingControl';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);
// Vue.component('TemporarySave', TemporarySave);

@Component
export default class ApplicationFormConstruction extends ApiAccessBase {
  // 処理状況
  protected statusValue: string = '';
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  // 業者種別
  private traderType = applicationFormModule.GET_APP_TYPE;
  // 発注者かどうか
  private isOrderUser = supervisingModule.IS_ORDER_USER;
  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;
  private GROUP_LAYOUT_LIST: string = Constants.GROUP_LAYOUT_LIST;

  // 参照モードかどうか
  private isReadMode: boolean = true;
  // 更新モードかどうか
  private isUpdateMode: boolean = false;
  // 継続申請かどうか
  private isContinueProcess: boolean = false;
  // 変更申請かどうか（確認画面遷移制御用）
  private isChangeProcess: boolean = false;
  // 他登録画面系ボタンの使用可否
  private isEnableEtcRegistButton: boolean = true;
  // 経審情報ボタンの使用可否
  private isEnableKeishinButton: boolean = true;
  // 経審情報再反映ボタンの使用可否
  private isEnableKeishinReflectButton: boolean = true;
  // 2023/10/10 [2023L-05] add start
  // 登録済みかつ申請書が未提出かどうか
  private isRegistrationNotSubmit: boolean = false;
  // 2023/10/10 [2023L-05] add end
  // 2023.10.20 [2023L-04] add start
  // 無害化apかどうか
  private isDetoxAp: boolean = supervisingModule.IS_DETOX_AP;
  // 2023.10.20 [2023L-04] add end
  /**
   * 初期化処理created
   */
  private created() {
    this.screenTitle = '新規/継続申請登録';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    if (this.traderType !== UketsukeConstants.APP_FORM_CONST) {
      // 工事、発注者以外は経審情報ボタン、経審情報再反映ボタン非表示
      this.isEnableKeishinButton = false;
      this.isEnableKeishinReflectButton = false;
    }
    let path = this.APP_PATH;
    // 初期表示
    if (!applicationFormModule.IS_SET_TRADER_ID) {
      // 新規登録
      path = path + '/init';
    } else {
      if (applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.CONTINUE) {
        // 継続（新規)
        path = path + '/get/init_continue';
        this.isContinueProcess = true;
      } else if (!applicationFormModule.IS_SET_CHANGE_TYPE && applicationFormModule.GET_PROCESS_TYPE !== ApplicationProcessType.CHANGE) {
        // 通常の修正
        path = path + '/get/normal/' + applicationFormModule.GET_PROCESS_TYPE;
      } else if (applicationFormModule.GET_CHANGE_TYPE === ApplicationChangeType.CONTINUED) {
        if (applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.CHANGE) {
          // 変更（修正）
          path = path + '/get/change/' + applicationFormModule.GET_PROCESS_TYPE;
          this.isChangeProcess = true;
        } else {
        // 継続（修正）
        path = path + '/get/continue/' + applicationFormModule.GET_PROCESS_TYPE;
        }

      } else {
        // 変更（修正）
        path = path + '/get/change/' + applicationFormModule.GET_PROCESS_TYPE;
        this.isChangeProcess = true;
      }
      // ボタン制御
      if (applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.CHANGE) {
        // 変更申請時登録を行うまでは
        this.isEnableEtcRegistButton = false;
        this.isEnableKeishinButton = false;
        this.isEnableKeishinReflectButton = false;
      }
      path = path + '/' + applicationFormModule.GET_TRADER_ID;
    }
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          // パネル設定全オープン
          this.exPanel.push(panelIndex);
          panelIndex++;
          this.variableColNames.push(variablecol);
        }
        this.exPanelBk = this.exPanel.concat();
        this.isReadMode = supervisingModule.IS_MODE_READ;
        this.isUpdateMode = supervisingModule.CHECK_MODE_UPDATE;
        // 新規の場合
        if (supervisingModule.GET_MODE === ScreenMode.CREATE) {
          // 空白のまま
          if (applicationFormModule.GET_NENDO !== '') {
            this.formData.nendo = applicationFormModule.GET_NENDO;
            this.syncFormDataToVariableCols();
          }
        } else {
          // 処理状況表示
          this.statusValue = '処理状況：' + this.formData.status;
          // 2023/10/10 [2023L-05] add start
          // 処理状況が入力中(登録しているが申請書が未提出)なら、申請書の提出を促すメッセージを表示する状態に変更する。
          if (this.formData.status.substring(0, 3) === '入力中') {
            this.isRegistrationNotSubmit = true;
          }
          // 2023/10/10 [2023L-05] add end
        }
      } else {
        // 修正可能な状態ではない場合
        this.isEnableEtcRegistButton = false;
        this.isEnableKeishinButton = false;
        this.isEnableKeishinReflectButton = false;
      }
    });
  }
  /**
   * 初期化処理mounted
   */
  private mounted() {
    this.$nextTick(function() {
      // 子コンポーネントマウントが完了した状態で実行
      this.moldingSendForm(this.$refs.form);
    });
  }

  /**
   * 申請書登録
   */
  private registAppForm() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // 登録処理（省略中）
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      this.exPanelAllOpen();
      const errorBag: any = this.getFormErrorData(this.$refs.form);

      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }

    let path = this.APP_PATH;
    let isCreate: boolean = false;
    let isCreateContinue: boolean = false;
    // モード判定
    if (supervisingModule.GET_MODE === ScreenMode.CREATE) {
      // 新規
      if (applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.NEW) {
        // 新規申請
        path = path + '/create/normal';
      } else {
        // 継続新規
        path = path + '/create/continue/' + applicationFormModule.GET_TRADER_ID;
        isCreateContinue = true;
      }
      isCreate = true;
    } else {
      if (!applicationFormModule.IS_SET_CHANGE_TYPE && applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.CORRECT) {
        // 通常の修正
        path = path + '/update/normal';
      } else if (applicationFormModule.GET_CHANGE_TYPE === ApplicationChangeType.CONTINUED
       && applicationFormModule.GET_PROCESS_TYPE === ApplicationProcessType.CORRECT) {
        // 修正（継続）
        path = path + '/update/continue';
      } else {
        // 修正（変更）
        path = path + '/update/change/' + applicationFormModule.GET_PROCESS_TYPE;
      }
      path = path + '/' + applicationFormModule.GET_TRADER_ID;
      // this.formData['traderId'] = applicationFormModule.GET_TRADER_ID;
    }
    // 登録
    this.apiAccess(path, Constants.API_METHOD_POST, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        if (isCreate) {
          if (isCreateContinue) {
            // 画面遷移時のTraderIdを退避しておく
            applicationFormModule.setBeforeTraderId(applicationFormModule.GET_TRADER_ID);
          }
          // レスポンスのTraderIdを設定
          applicationFormModule.setTraderId(this.formData.traderId);
        }
        // 処理を申請書修正に設定
        applicationFormModule.setProcessType(ApplicationProcessType.CORRECT);
        this.isReadMode = supervisingModule.IS_MODE_READ;
        this.isUpdateMode = supervisingModule.CHECK_MODE_UPDATE;
        // 変更区分の設定
        if (this.isChangeProcess) {
          applicationFormModule.setChangeType(ApplicationChangeType.CHANGE);
        } else if (this.isContinueProcess) {
          applicationFormModule.setChangeType(ApplicationChangeType.CONTINUED);
        }
        // 2023/10/10 [2023L-05] add start
        // 処理状況の再表示
        this.statusValue = '処理状況：' + this.formData.status;
        // 申請書の提出を促すメッセージを表示する状態に変更する。
        this.isRegistrationNotSubmit = true;
        // 2023/10/10 [2023L-05] add end
      }
      this.isEnableEtcRegistButton = true;
      if (this.traderType === UketsukeConstants.APP_FORM_CONST) {
        // 工事、発注者以外は経審情報ボタン、経審情報再反映ボタン非表示
        this.isEnableKeishinButton = true;
        this.isEnableKeishinReflectButton = true;
      }
    });
    // 先頭へジャンプ
    this.hrefElement('af-const', -50);
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    if (!this.isReadMode) {
    // 2023/10/10 [2023L-05] upd start
    //  if (!confirm(Message.I0014)) {
    //    return;
    //  }
      if (this.isRegistrationNotSubmit) {
        if (!confirm(Message.I0036)) {
          return;
        }
      } else {
        if (!confirm(Message.I0014)) {
          return;
        }
      }
    // 2023/10/10 [2023L-05] upd end
    }
    if (supervisingModule.CHECK_MODE_UPDATE) {
      this.apiAccess(this.APP_PATH + '/exclusive/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //継続申請時の前回データも解除
          if (applicationFormModule.IS_SET_BEFORE_TRADER_ID) {
            this.apiAccess(this.APP_PATH + '/exclusive/' + applicationFormModule.GET_BEFORE_TRADER_ID, Constants.API_METHOD_POST, false, true)
            .then((result2) => {
              if (result2 === Constants.API_RESULT_SUCCES) {
                applicationFormModule.moduleResetDetail();
              }
            });
          } else {
            applicationFormModule.moduleResetDetail();
          }
          this.backScreen();
        }
      });
    } else {
      applicationFormModule.moduleResetDetail();
      this.backScreen();
    }
  }
  /**
   * 戻る
   */
  private backScreen() {
    if (supervisingModule.IS_ORDER_USER) {
      router.push({name: applicationFormModule.GET_TRANSITION_SOURCE_SCREEN});
    } else {
      router.push('accepterMainMenu');
    }
  }

  private exPanelAllClose() {
    this.exPanel = [];
  }
  private exPanelAllOpen() {
    this.exPanel = this.exPanelBk.concat();
  }
  /**
   * 申請書提出（確認）
   */
  private confirmAppForm() {
    // 判定方法
    if (this.isChangeProcess) {
      router.push('appFormConfirmChange');
    } else {
      router.push('appFormConfirm');
    }
  }
  /**
   * 個別情報登録（市町村選択）
   */
  private municipalitySelect() {
    router.push('municipalitySelect');
  }
  /**
   * 経審情報
   */
  private keishinSelect() {
    router.push('traderInfoWorkTypes');
  }
  /**
   * 経審情報再反映
   */
  private registKeishin() {
    if (!confirm(Message.I0030)) {
      return;
    }
    // form成形
    this.moldingSendForm(this.$refs.form);
    let path = this.APP_PATH;
    path = path + '/update/keishin' + '/' + applicationFormModule.GET_TRADER_ID;
    this.apiAccess(path, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
    });
    // 先頭へジャンプ
    this.hrefElement('af-const', -50);
  }
  // 2023.09.11 [2023F-B] add start
  /**
   * 申請一時ファイル保存
   */
  private appTemporaryFileSaving(form: any) {
    this.temporaryFileSaving(form, this.getAppTemporaryFileKey());
  }
  /**
   * 申請一時ファイル選択
   */
  private appSelectedTemporaryFile() {
    this.selectedTemporaryFile(this.getAppTemporaryFileKey());
  }
  /**
   * 申請一時ファイルキー取得
   */
  private getAppTemporaryFileKey() {
    // 年度（版）回収のためフォーム同期
    this.moldingSendForm(this.$refs.form);
    return supervisingModule.GET_TENANT_ID + ':' + applicationFormModule.GET_APP_TYPE + ':' + this.formData.nendo;
  }
  // 2023.09.11 [2023F-B] add end

}
